defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Components/BuyCoupon',
  [
    'Shared/Framework/Mithril/Scripts/Core/Component',
    'Shared/Framework/Mithril/Scripts/Helpers/Storage',
    'Shared/Framework/Ensighten/Scripts/Ensighten',
    'Common/Framework/EventHandling/Scripts/Event',
    'DanskeSpil/Framework/NumberGames/Scripts/Helpers/Params',
    'DanskeSpil/Domain/NumberGames/Scripts/Helpers/CampaignEngineApi',
    'DanskeSpil/Domain/Subscriptions/Scripts/Helpers/ModelStorage',
    'DanskeSpil/Domain/Subscriptions/Scripts/Models/Subscription',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Dictionary',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Utils',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Api',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/PurchaseFlow/FreeDeposit',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/PurchaseFlow/FixedDeposit',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Card/CardFlowHeader',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Clubs/ClubPage'
  ],
  function (Component, Storage, Ensighten, Event, Params, CampaignEngineApi, SubscriptionBasket, SubscriptionModel, PlayTogetherDictionary, Utils, PlayTogetherApi, FreeDeposit, FixedDeposit, CtaButton, CardFlowHeader, ClubPage) {

    // Component:
    Component('buy-coupon', [PlayTogetherDictionary], function (m, route, settings, property) {
      const gameTypePathsMap = {
        lotto: 'Lotto',
        eurojackpot: 'Eurojackpot',
        vikinglotto: 'VikingLotto'
      };

      // Components:
      var root = {
        controller: function () {
          this.settings = settings;
          this.property = property;
          this.navigationPaths = settings.navigation;
          this.rootDictionary = PlayTogetherDictionary;
          this.dictionary = this.rootDictionary.get.bind({ prefix: 'BuyCoupon/' });

          this.playId = m.prop(Params.extract('spilId'));
          this.subscriptionGroupGameId = m.prop(Params.extract('subscriptionGroupGameId'));
          this.playType = 'Lightning';

          this.pageTitle = m.prop(null);
          this.pageDescription = m.prop(null);
          this.game = m.prop(null);
          this.processing = m.prop(false);
          this.drawsInCampaignCount = m.prop(0);
          this.useCampaignFlowGraphics = m.prop(false);
          this.checkingCampaignEngine = m.prop(false);
          this.hasActiveCampaignFromCampaignEngine = m.prop(false);
          this.activeCampaignFromCampaignEngineData = m.prop(null);
          this.campaignInformModalContent = m.prop(null);
          this.subscriptionGroupConflict = m.prop(null);
          this.subscriptionGroupModalActive = m.prop(false);

          this.play = () => {
            if (this.subscriptionGroupGameId()) {
              handleSubscriptionGroupConflict();
              return this.property('clubPageController')?.clubModel()?.getPlayBySubscriptionGroupGameId(this.subscriptionGroupGameId());
            }
            return this.property('clubPageController')?.clubModel()?.getPlayById(this.playId());
          };

          this.gameType = () => {
            const gameType = this.play()?.game.toLowerCase();
            if (gameType === 'lottosaturday') {
              return 'lotto';
            }
            return gameType;
          };

          this.depositType = () => {
            return this.play()?.depositType;
          };

          this.multiWagerSuffix = () => {
            const isMultiWager = this.play()?.numberOfDraws > 1;
            let multiWagerSuffix = isMultiWager ? 'MultiWager' : '';
            if (isMultiWager && this.gameType() === 'eurojackpot') {
              multiWagerSuffix += 'Eurojackpot';
            }

            return multiWagerSuffix;
          };

          this.playAsSubscription = () => {
            const gameModel = this.depositType() === 'Free' ? this.property('gameModel') : this.game;
            gameModel().status('basket');
            this.game().verticalType('plus');
            gameModel().numberOfDraws(1);
            gameModel().save();
            SubscriptionBasket.clear('plus', this.property('clubPageController').clubId());
            SubscriptionBasket.add('plus', this.gameType().toLowerCase(), gameModel().playType().toLowerCase(), gameModel().id(), this.property('clubPageController').clubId());

            const clubSubscription = SubscriptionModel.new({
              id: `PlayTogether-${this.property('clubPageController').clubId()}`,
              verticalType: 'plus',
            });
            clubSubscription.status('basket');
            clubSubscription.clubId(this.property('clubPageController').clubId());
            clubSubscription.startUrl(location.href);
            clubSubscription.clubPageUrl(`${this.navigationPaths.clubPage}?klubId=${this.property('clubPageController').clubId()}`);
            if (this.property('clubPageController').clubSettings().allowAllInvite() || this.property('clubPageController').isCurrentUserChairman()) {
              clubSubscription.clubInviteUrl(`${this.navigationPaths.showInvitePage}?klubId=${this.property('clubPageController').clubId()}`);
            }
            clubSubscription.save();

            window.location.href = `${this.navigationPaths.subscriptionConfirmationPage}?plus&clubId=${this.property('clubPageController').clubId()}`;
          };

          this.showBuyAsSubscriptionModal = () => {
            const modalContent = this.property('clubPageController').modal.defaultContentTemplate({
              body: [
                m('.modal-heading', this.rootDictionary.get('ChooseWeeks/PlayAsSubscriptionModal/Heading')),
                m('.modal-subheading', this.rootDictionary.get('ChooseWeeks/PlayAsSubscriptionModal/Subheading')),
                m('div', this.rootDictionary.get('ChooseWeeks/PlayAsSubscriptionModal/Description'))
              ],
              footer: [
                CtaButton({
                  text: this.rootDictionary.get('ChooseWeeks/PlayAsSubscriptionModal/CancelButton'),
                  onClick: () => {
                    this.property('clubPageController').modal.close();
                  }
                }),
                CtaButton({
                  text: this.rootDictionary.get('ChooseWeeks/PlayAsSubscriptionModal/ConfirmButton'),
                  onClick: this.playAsSubscription,
                  options: ['primary']
                })
              ]
            });

            this.property('clubPageController').modal.setContent(modalContent);
            this.property('clubPageController').modal.show();
            this.property('clubPageController').modal.onClose(() => {
              this.processing(false);
            });
          };

          this.action = () => {
            this.processing(true);
            let gameInstanceId = null;
            let gameModel = null;
            if (this.depositType() === 'Free') {
              gameModel = this.property('gameModel');
              gameInstanceId = this.property('gameModel')().id();
            } else {
              gameModel = this.game;
              gameInstanceId = this.game().id();
            }
            gameModel().playTogetherDepositType(this.depositType());
            gameModel().save();

            if (this.play().subscriptionGroupGameId) {
              gameModel().subscriptionGroupGameId(this.play().subscriptionGroupGameId);
              gameModel().save();
              this.showBuyAsSubscriptionModal();
              return;
            }
            const gameTypePath = gameTypePathsMap[this.gameType().toLowerCase()];
            window.location.href = this.navigationPaths.createPlayConfirmPage + '?gameInstanceId=' + gameInstanceId + '&gameType=' + gameTypePath + '&klubId=' + this.property('clubPageController').clubId() + '&spilId=' + this.playId();
          };

          this.clubPageClassName = () => {
            let className = `play-together-buy-coupon ${this.gameType()?.toLowerCase()}`;
            if (this.depositType() === 'Free') {
              className += ' choose-rows-section';
            }
            return className;
          };

          this.showCampaignInformOverlay = (forceShow) => {
            if (!this.campaignInformModalContent()) {
              return;
            }

            if (!forceShow &&
              Storage.get(`PlayTogether-campaign-onboarding-${this.playId()}`)) {
              return;
            }
            const clubPageModal = this.property('clubPageController').modal;

            clubPageModal.className('campaign-overlay__custom-campaign');
            clubPageModal.setContent(this.campaignInformModalContent());
            clubPageModal.show();
          };

          const checkForLottoExtraCampaigns = () => {
            const onConfirm = () => {
              Event.fire('ds.event.accordionInfoOverlay:show', {
                key: 'productchange'
              });
              Ensighten.pushGaEvent('onboarding_popup', 'cta_click', '');
              Storage.set(`extraCampaignOverlayIdentifier-${this.playId()}`, true);
            };

            const onClose = () => {
              Ensighten.pushGaEvent('onboarding_popup', 'closed', '');
            };

            if (!Storage.get(`extraCampaignOverlayIdentifier-${this.playId()}`) &&
                this.gameType() === 'lotto' &&
                this.game()?.infoFeed().getOpenDraw()?.gameVersionNo > 2) {
              Event.fire('ds.event.accordionInfoOverlay:show', {
                key: 'readmore',
                onConfirm,
                onClose
              });
              Ensighten.pushGaEvent('onboarding_popup', 'shown', '');
            }
          };

          this.useCampaignEngineInit = () => {
            checkForLottoExtraCampaigns();
            this.useCampaignEngine = this.settings.campaigns?.[this.gameType().toLowerCase()]?.useEngine;
            if (this.useCampaignEngine) {
              CampaignEngineApi.getActiveCampaignForGame(this.gameType().toLowerCase())
                .then((response) => {
                  this.checkingCampaignEngine(false);
                  this.hasActiveCampaignFromCampaignEngine(true);
                  this.activeCampaignFromCampaignEngineData(response);
                  property('activeCampaignFromCampaignEngineData', response);

                  this.useCampaignFlowGraphics(response.activeCampaign.features.enablePurchaseFlowGraphics);
                  Utils.setCssHslVariables({
                    hexColor: response.graphics.primaryColor,
                    variableName: 'campaign-theme-primary'
                  });
                  Utils.setCssHslVariables({
                    hexColor: response.graphics.secondaryColor,
                    variableName: 'campaign-theme-secondary'
                  });
                  Utils.setCssHslVariables({
                    hexColor: response.graphics.tertiaryColor,
                    variableName: 'campaign-theme-tertiary'
                  });

                  this.drawsInCampaignCount(this.game().campaignDrawsCount?.(response.activeCampaign.campaignNo));

                  if (response.activeCampaign.features.enableOnboarding) {
                    const clubPageModal = this.property('clubPageController').modal;
                    const campaignTexts = response.texts;
                    const modalContent = clubPageModal.defaultContentTemplate({
                      body: [
                        m('.icon-wrapper', m('img', { src: response.graphics.logoSimple })),
                        m('.headline', campaignTexts.onboardingPlayTogetherTitle),
                        m('p.text', campaignTexts.onboardingPlayTogetherBody)
                      ],
                      footer: CtaButton({
                        text: this.rootDictionary.get('Shared/OkButton'),
                        onClick: () => {
                          Storage.set(`PlayTogether-campaign-onboarding-${this.playId()}`, true);
                          clubPageModal.close();
                        },
                        options: ['primary']
                      })
                    });
                    this.campaignInformModalContent(modalContent);
                    if (this.drawsInCampaignCount()) {
                      this.showCampaignInformOverlay();
                    }
                  }

                  m.redraw(true);
                })
                .catch(() => {
                  this.checkingCampaignEngine(false);
                });
            }
          };

          property('campaignTicketCounter', ({ rows }) => {
            if (['christmas', 'easter'].includes(property('activeCampaignFromCampaignEngineData')?.campaignTag.toLowerCase())) {
              return null;
            }

            let ticketCounterText = null;
            if ((property('isOpenDrawPartOfCampaign')?.() &&
                property('activeCampaignFromCampaignEngineData')) ||
                property('activeCampaignFromCampaignEngineData')?.campaignType === 'EachDraw') {
              ticketCounterText = this.dictionary(`CampaignEngine/${gameTypePathsMap[this.gameType().toLowerCase()]}/Description`, {
                campaignName: property('activeCampaignFromCampaignEngineData').title,
                ticketsCount: rows
              });
            }

            return ticketCounterText ? m('.play-together__choose-rows-ticket-counter',
              m('.client-game-description__inner', m.trust(ticketCounterText)),
              property('activeCampaignFromCampaignEngineData').campaignType === 'EachDraw' ? m('.client-game-description__question-button', {
                onclick: () => this.showCampaignInformOverlay(true)
              },
              m('svg.icon', [
                m('use', { href: '/Components/DanskeSpil/Domain/NumberGames/Graphics/SpriteSheets/MultiClientCommonIcons.svg#question-icon' })
              ])
              ) : null
            ) : null;
          });

          property('specialCampaignTicketCounter', ({ rows }) => {
            let ticketCounterText = null;
            let campaignIcon = '';
            const campaignTag = property('activeCampaignFromCampaignEngineData')?.campaignTag.toLowerCase();

            if (['christmas', 'easter'].includes(campaignTag)) {
              const descriptionText = campaignTag === 'christmas' ? 'ChristmasDescription' : 'EasterDescription';
              campaignIcon = `/Components/DanskeSpil/Domain/Lotto/Graphics/SpriteSheets/${campaignTag === 'christmas' ? 'LottoChristmas/multi-week-package.svg' : 'LottoEaster/add-on-ticket.svg'}`;
              ticketCounterText = this.dictionary(`CampaignEngine/Lotto/${descriptionText}`, {
                campaignName: property('activeCampaignFromCampaignEngineData').title,
                ticketsCount: rows
              });
            }

            return ticketCounterText ? m('.play-together__buy-coupon-christmas-ticket',
              {
                onclick: () => {
                  Event.fire('ds.event.accordionInfoOverlay:show', {
                    key: 'productchange'
                  });
                }
              },
              m('img.play-together__buy-coupon-christmas-ticket-badge', {
                src: campaignIcon
              }),
              m('.play-together__buy-coupon-christmas-ticket-text', [
                m('span', '+'),
                m.trust(ticketCounterText)
              ]),
              m('img.play-together__buy-coupon-christmas-ticket-question-mark', {
                src: '/Components/DanskeSpil/Domain/Lotto/Graphics/SpriteSheets/LottoChristmas/goldquestion-mark.svg'
              })
            ) : null;
          });

          const handleSubscriptionGroupConflict = () => {
            if (!this.subscriptionGroupConflict() ||
                !this.property('clubPageController') ||
              this.subscriptionGroupModalActive()) {
              return;
            }

            let goToSubscriptionLink = `/plus-abonnement/mellemliggende-betaling?subscriptionId=${this.subscriptionGroupConflict().affectedSubscriptionId}`;
            const dictionaryOptions = {};

            if (this.subscriptionGroupConflict().errorCode === 'GROUP_ARCHIVED_SUBSCRIPTION_CONFLICT') {
              goToSubscriptionLink = `${this.navigationPaths.mySubscriptionsPage}/abonnement?subscriptionId=${this.subscriptionGroupConflict().affectedSubscriptionId}`;
              dictionaryOptions.subscriptionEndDate = Utils.parseISO8601(this.subscriptionGroupConflict().affectedSubscriptionId)?.dateObject?.toLocaleDateString();
            }

            const modalContent = this.property('clubPageController').modal.defaultContentTemplate({
              body: [
                m('.modal-heading', this.rootDictionary.get('SubscriptionGroupConflict/Heading')),
                m('div', this.rootDictionary.get(`SubscriptionGroupConflict/${this.subscriptionGroupConflict().errorCode}`, dictionaryOptions))
              ],
              footer: [
                CtaButton({
                  text: this.rootDictionary.get('SubscriptionGroupConflict/GoToSubscriptionButton'),
                  onClick: () => {
                    window.location.href = goToSubscriptionLink;
                  },
                  options: ['primary']
                }),
                CtaButton({
                  text: this.rootDictionary.get('SubscriptionGroupConflict/GoToClubButton'),
                  onClick: () => {
                    window.location.href = `${this.navigationPaths.clubPage}?klubId=${this.property('clubPageController').clubId()}`;
                  },
                  options: ['secondary']
                })
              ]
            });
            this.property('clubPageController').modal.setContent(modalContent);
            this.property('clubPageController').modal.show();
            this.subscriptionGroupModalActive(true);
          };

          if (this.subscriptionGroupGameId()) {
            this.processing(true);

            PlayTogetherApi.validateGroupSubscriptionConflict(this.subscriptionGroupGameId())
              .then(() => {
                this.processing(false);
                m.redraw();
              })
              .catch((response) => {
                this.processing(false);
                m.redraw();

                this.subscriptionGroupConflict(response);
              });
          }
        },

        view: function (controller) {
          return m(ClubPage, { controller }, {
            flowHeader: CardFlowHeader({
              goBack: () => {
                window.history.back();
              }
            }),
            title: controller.pageTitle(),
            description: controller.pageDescription(),
            content: controller.depositType() === 'Free' ? FreeDeposit : FixedDeposit
          });
        }
      };

      // Routes:
      route('/', root);
    });

  });
